import { SplitPayments } from '../../pages';
import {
	InventoryController,
	WalletController,
	TransactionsController,
} from '../../controllers';
import React, { useEffect, useMemo, useState } from 'react';
import * as yup from 'yup';
import { theYear } from '../../utils/utils';
import { useStores } from '../../stores';
import { Inventory } from '../../pages';
import { observer } from 'mobx-react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import moment from 'moment';
import { getDate } from '../../utils/utils';
import { filterPeriods } from '../../utils/utils';

const SplitPaymentsContainer = () => {
	const [openSplitViewMoreModal, setOpenSplitViewMoreModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(theYear);
	const [onReset, setOnReset] = useState(false);

	const [limit, setLimit] = useState(50);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const { transactionStore } = useStores();

	const { splitAnalysis } = TransactionsController;

	const splitPaymentTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { isLoading, data, isFetching, refetch } =
		TransactionsController.useGetSplitPayments(
			splitPaymentTableQuery,
			filterQuery,
			searchQuery
		);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([splitAnalysis()]);
			setLoading(false);
		};
		setTransactions();
	}, [splitAnalysis]);

	const validationSchema = () => {
		return yup.object({
			startDate: yup.string().required('Start Date is required'),
			endDate: yup.string().required('End Date is required'),
		});
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}`;
			if (payload.period === 'custom') {
				setFilterPeriod(
					`${moment(payload?.startDate).format('DD-MM-YYYY')} - ${moment(payload.endDate).format('DD-MM-YYYY')}`
				);
			} else {
				setFilterPeriod(`${payload?.periodText}`);
			}
		}
		setLoading(true);
		setFilterQuery(query);
		await Promise.all([refetch(query), splitAnalysis(query)]);
		setLoading(false);
	};

	const refresh = async () => {
		setLoading(true);
		await Promise.all([refetch(), splitAnalysis()]);
		setLoading(false);
	};

	const resetFilter = async () => {
		await onSubmit();
		setFilterPeriod(`${theYear}`);
	};

	const closeModal = () => {
		setOpenSplitViewMoreModal(false);
		transactionStore.setSelectedSplitTrans({});
	};

	const showViewMoreState = transaction => {
		transactionStore.setSelectedSplitTrans(transaction);
		setOpenSplitViewMoreModal(true);
	};

	return (
		<SplitPayments
			setOnReset={setOnReset}
			onReset={onReset}
			filterPeriod={filterPeriod}
			setFilterPeriod={filterPeriod}
			resetFilter={resetFilter}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			closeModal={closeModal}
			openSplitViewMoreModal={openSplitViewMoreModal}
			showViewMoreState={showViewMoreState}
			refresh={refresh}
			loading={loading}
			getDate={getDate}
			filterPeriods={filterPeriods}
			isLoading={isLoading}
			data={data}
			isFetching={isFetching}
			limit={limit}
			onLimitChange={onLimitChange}
			currentPage={currentPage}
			setCurrentPage={setCurrentPage}
			setSearchQuery={setSearchQuery}
			setFilterQuery={setFilterQuery}
			refetch={refetch}
		/>
	);
};

export default SplitPaymentsContainer;
